module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Light.woff
// module id = 1901
// module chunks = 0